import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCustomEevents } from "@/api/dataAll/customEvents";
import { tabulation, gmToolNewPage } from "@/mixins/index";
export default {
  name: "customEvents",
  mixins: [tabulation, gmToolNewPage],
  data: function data() {
    return {
      currentPage: 1,
      tableData: [],
      tableColumn: [{
        label: this.$t('gameName'),
        prop: "game"
      }, {
        label: this.$t('platform'),
        prop: "platform"
      }, {
        label: this.$t('channel'),
        prop: "channel"
      }, {
        label: this.$t('pkgLabel'),
        prop: "pkg"
      }, {
        label: this.$t('adChannel'),
        prop: "ad_channel"
      }, {
        label: this.$t('adPlacement'),
        prop: "ad_placement"
      }, {
        label: this.$t('eventName'),
        prop: "func"
      }, {
        label: this.$t('deviceId'),
        prop: "device_id"
      }, {
        label: this.$t('userId'),
        prop: "user_id"
      }, {
        label: this.$t('roleId'),
        prop: "role_id"
      }, {
        label: this.$t('date'),
        prop: "date"
      }, {
        label: this.$t('time'),
        prop: "time"
      }, {
        label: this.$t('operation'),
        prop: "action"
      }, {
        label: this.$t('extendedBehavior'),
        prop: "ext"
      }, {
        label: this.$t('ip'),
        prop: "ip"
      }, {
        label: this.$t('level'),
        prop: "level"
      }],
      roleList: [{
        label: this.$t('distinctRoleId'),
        value: true
      }],
      eventList: [{
        label: this.$t('loginLabel'),
        value: 'login'
      }, {
        label: this.$t('register'),
        value: 'register'
      }, {
        label: this.$t('rechargeLabel'),
        value: 'recharge'
      }, {
        label: this.$t('activity'),
        value: 'activity'
      }, {
        label: this.$t('createRole'),
        value: 'create_role'
      }],
      userList: [{
        label: this.$t('allUsers'),
        value: 'all'
      }, {
        label: this.$t('payingUsers'),
        value: 'paying'
      }, {
        label: this.$t('nonPayingUsers'),
        value: 'not_paying'
      }],
      searchData: {
        page: 1,
        page_size: 10
      },
      total: 0
    };
  },
  created: function created() {},
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$$route$params, func, user_id, device_id, starttime, endtime, dateRange;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // let paramsData = this.$route.params;
              _this$$route$params = _this.$route.params, func = _this$$route$params.func, user_id = _this$$route$params.user_id, device_id = _this$$route$params.device_id, starttime = _this$$route$params.starttime, endtime = _this$$route$params.endtime;
              console.log("this.$route.query", _this.$route.params);
              _this.searchData = Object.assign({}, _this.searchData, {
                func: func,
                user_id: user_id,
                device_id: device_id
              });

              if (starttime && endtime) {
                dateRange = [starttime, endtime];
                _this.value2 = dateRange; // 核心：手动调用子组件的方法来更新它内部的输入框显示
                // 假设子组件内部用来接收日期的变量名或方法需要被触发

                _this.$nextTick(function () {
                  if (_this.$refs.screening) {
                    // 如果子组件支持外部修改日期，通常会有一个 set 方法或直接修改其属性
                    // 下面这行代码取决于 dataScreening 组件内部是怎么写的
                    // 常见的做法是修改子组件内部绑定的 data
                    _this.$refs.screening.value2 = dateRange;
                  }
                });
              }

              console.log("this.searchData", _this.searchData);

              if (_this.searchData.user_id || _this.searchData.func || _this.searchData.device_id) {
                _this.getList(1);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.searchData.page = e;

                if (!(!_this2.searchData.user_id && !_this2.searchData.role_id && !_this2.searchData.func && !_this2.searchData.device_id)) {
                  _context2.next = 4;
                  break;
                }

                _this2.$message.error(_this2.$t('pleaseSelectOneCondition'));

                return _context2.abrupt("return");

              case 4:
                if (_this2.value2.length > 0) {
                  _this2.searchData.starttime = _this2.value2[0];
                  _this2.searchData.endtime = _this2.value2[1];
                } // this.paramsData.page = e;


                _this2.searchData.action = _this2.searchData.func == 'action' ? _this2.searchData.action : '';
                _this2.reqLoading = true;
                getCustomEevents(_objectSpread({}, _this2.searchData)).then(function (res) {
                  if (res.status == 200) {
                    var data = res.data;
                    _this2.tableData = res.data.data; // let tableNewdata = res.data;
                    // this.tableCopyTableList = JSON.parse(JSON.stringify(tableNewdata))
                    // this.tableData = this.currentChangePage(this.pageSize, this.currentPage)

                    _this2.total = res.data.total ? parseInt(res.data.total) : 0;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getList(1);
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this3.searchData.user_id && !_this3.searchData.role_id && !_this3.searchData.func && !_this3.searchData.device_id)) {
                  _context3.next = 3;
                  break;
                }

                _this3.$message.error(_this3.$t('pleaseSelectOneCondition'));

                return _context3.abrupt("return");

              case 3:
                if (_this3.value2.length > 0) {
                  _this3.searchData.starttime = _this3.value2[0];
                  _this3.searchData.endtime = _this3.value2[1];
                }

                getCustomEevents(_objectSpread(_objectSpread({}, _this3.searchData), {}, {
                  page_size: -1
                })).then(function (res) {
                  if (res.status == 200) {
                    var list = res.data;

                    _this3.$export.excel({
                      columns: _this3.tableColumn,
                      data: list,
                      title: _this3.$route.meta.title
                    });
                  }
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};